<template>
  <main>
    <div class="teacher barfiltre">
      <div class="row">
        <div class="col-md-12">
          <TopTemplate>
            <template v-slot:left-element>
              <h3>{{ $t("title.listTeacher") }} ({{ total }})</h3>
            </template>

            <template v-if="statusSchoolYear" v-slot:right-element>
              <router-link :to="{name: 'add_teacher'}" class="btn button btn-primary" :disabled="loading">
                <i class="icon-Add" />
                {{ $t("button.addTeacher") }}
              </router-link>
            </template>
          </TopTemplate>
          <div class="search-date-wrapper search-filter-wrapper" :class="showFil === false ? 'borderNan' : ''">
            <div class="col-md-11 search searchTeacher">
              <input v-model="params.q" type="text" placeholder="Recherche" name="search" @input="searshTeacher()" />
              <img src="../../assets/icons/search-icon.svg" class="icon-search" alt="search" />
            </div>
            <div class="date-wrapper filter-wrapper" @click="showFilter()">
              <span>{{ $t("barFiltre.filtre") }}</span>
            </div>
          </div>
          <div v-if="showFil" class="row container-select container-filter">
            <div v-if="selectedClass.length > 0 || selectedCourse.length > 0" class="col-md-12">
              <div class="reset_student" @click="resetFilter()">
                <i class="icon-reset" />
                {{ $t("barFiltre.renitialiser") }}
              </div>
            </div>
            <div class="col-md-4 select-wrapper">
              <span class="title-select">{{ $t("barFiltre.statut") }}</span>
              <v-select v-model="params.selected_status" :options="status" :searchable="true" label="name" :reduce="(option) => option" @update:modelValue="ChangeStatus($event)">
                <template #no-options="{search, searching, loading}">
                  {{ $t("common.emptySystem") }}
                </template>
              </v-select>
            </div>
            <div class="col-md-4 select-wrapper">
              <span class="title-select">{{ $t("barFiltre.classe") }}</span>
              <v-select v-model="selectedClass" :options="classes" :searchable="true" label="name" multiple :reduce="(option) => option" @update:modelValue="ChangeClass($event)">
                <template #no-options="{search, searching, loading}">
                  {{ $t("common.emptysearchClasse") }}
                </template>
              </v-select>
            </div>
            <div class="col-md-4 select-wrapper">
              <span class="title-select">{{ $t("barFiltre.course") }}</span>
              <v-select
                v-model="selectedCourse"
                :options="courses"
                :searchable="true"
                label="name"
                multiple
                :reduce="(option) => option.id"
                @update:modelValue="ChangeCourse($event)"
              >
                <template #no-options="{search, searching, loading}">
                  {{ $t("common.emptysearchCourse") }}
                </template>
              </v-select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
      <div class="spinner-border text-info" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div class="container-fluid empty-message">
      <div class="col-md-12">
        <div v-if="!loading && teachers.length == 0" class="card mt-4">
          <div class="col-12 empty-result text-center pt-3">
            <p>{{ $t("common.emptysearshTeacher") }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="table teacher" v-if="!loading && teachers.length > 0">
      <div class>
        <div class="row">
          <div class="col-md-12">
            <div class="table__wrapper table-responsive-vertical table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th width="3em" align="left">
                      <label class="container-checkbox">
                        <input v-model="selectAll" type="checkbox" :disabled="!statusSchoolYear" />
                        <span class="checkmark checkmark__teacher"></span>
                      </label>
                    </th>
                    <th class="col-md-3">
                      {{ $t("teacher.tab.name") }}
                      <div class="icon-wrapper" @click="sortB('full_name')">
                        <i class="ri-arrow-up-s-line" :class="[specTri('full_name', true)]" />
                        <i class="ri-arrow-down-s-line" :class="[specTri('full_name', false)]" />
                      </div>
                    </th>
                    <th class="col-md-4">
                      <div class="row">
                        <span class="col-md-5">{{ $t("teacher.tab.class") }}</span
                        ><span class="col-md-7">{{ $t("teacher.tab.course") }}</span>
                      </div>
                    </th>

                    <th class="col-md-2">{{ $t("teacher.tab.status") }}</th>
                    <th class="col-md-2">{{ $t("teacher.tab.phone") }}</th>
                    <th class="col-md-1">{{ $t("common.actions") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="teacher in teachers" :key="teacher.id">
                    <td>
                      <label class="container-checkbox">
                        <input v-model="selected" type="checkbox" :value="teacher.id" :disabled="!statusSchoolYear" />
                        <span class="checkmark checkmark__detail"></span>
                      </label>
                    </td>
                    <td class="col-md-3">
                      <router-link
                        class="success_msg name_propre"
                        :to="{
                          name: 'DetailTeacher',
                          params: {id: teacher.id},
                        }"
                      >
                        <p>
                          <span v-if="teacher.last_name" class="lastName_propre"> {{ teacher.last_name }} </span>&nbsp;
                          <span v-if="teacher.first_name" class="name_propre">
                            {{ teacher.first_name }}
                          </span>
                        </p>
                      </router-link>
                    </td>

                    <td v-if="teacher.class_courses && teacher.class_courses.length > 0" class="col-md-4">
                      <div class="row" v-for="classe in teacher.class_courses" :key="classe.id">
                        <p v-if="classe.name" class="col-md-5">
                          {{ classe.name }}
                        </p>
                        <p v-if="classe.courses.length > 0" class="col-md-7">
                          <span v-for="(course, index) in classe.courses" :key="index">
                            <em>{{ course.name }}<em v-if="index + 1 < classe.courses.length">, </em></em>
                          </span>
                        </p>
                        <p v-if="classe.courses.length === 0" class="col-md-7">__</p>
                      </div>
                    </td>
                    <td v-else class="col-md-4">
                      <div class="row">
                        <p class="col-md-5">__</p>
                        <p class="col-md-7">__</p>
                      </div>
                    </td>
                    <td class="col-md-2">
                      <p>
                        <span :class="statusClass(teacher)"> {{ teacher.teacher_account_status === 1 ? $t("common.blocked") : statusText(teacher) }}</span>
                      </p>
                    </td>
                    <td>
                      <p v-if="formatPhone(teacher.phone)">{{ formatPhone(teacher.phone) }}</p>
                      <p v-else>__</p>
                    </td>

                    <td class="action">
                      <div class="espace_height">
                        <p>
                          <router-link
                            class="success_msg"
                            :to="{
                              name: 'DetailTeacher',
                              params: {id: teacher.id},
                            }"
                            @click="setItem()"
                          >
                            <i class="icon-eyes">
                              <span class="tooltiptext">{{ $t("button.tooltip.details") }}</span>
                            </i></router-link
                          >

                          <router-link
                            v-if="statusSchoolYear"
                            :to="{
                              name: 'EditTeacher',
                              params: {id: teacher.id},
                            }"
                            @click="setItem()"
                          >
                            <i class="icon-edit-02">
                              <span class="tooltiptext">{{ $t("button.tooltip.update") }}</span>
                            </i>
                          </router-link>
                          <i v-if="statusSchoolYear" class="icon-trash" @click.prevent="deleteTeacher(teacher.id)">
                            <span class="tooltiptext">{{ $t("button.tooltip.delete") }}</span>
                          </i>
                          <i class="icon-forbiden" @click.prevent="blocageTeacherFn(teacher)">
                            <span class="tooltiptext">{{ $t("button.tooltip.blocage") }}</span>
                          </i>
                        </p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="col-md-12 modal_dis">
                <div class="col-md-6">
                  <div class="row">
                    <div v-if="statusSchoolYear" class="col-md-12 delete-all-student">
                      <div class="button-delete">
                        <button @click.prevent="deleteSelected" class="btn btn-danger button" :disabled="selected.length == 0 ? true : false">
                          <i class="icon-trash"></i> {{ $t("button.delete") }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="table__wrapper__pagination-wrapper">
                    <div class="pagination">
                      <pagination v-if="last_page > 1" :dataSet="pagination" @goToPage="getResults" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import pagination from "../../components/navigation/Pagination";
import TeacherService from "../../services/teacher.service";
import {parsePhoneNumberFromString} from "libphonenumber-js";
import vSelect from "vue-select";
import moment from "moment";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import _ from "lodash";
import {mapGetters, mapActions} from "vuex";
export default {
  name: "TeachersList",
  components: {
    TopTemplate,
    pagination,
    "v-select": vSelect,
    Datepicker,
  },
  setup() {
    // In case of a range picker, you'll receive [Date, Date]
    const format = (due_date) => {
      const day = due_date.getDate();
      const month = due_date.getMonth() + 1;
      const year = due_date.getFullYear();
      if (day <= 9) {
        return `0${day}/${month}/${year}`;
      }
      if (day > 9) {
        return `${day}/${month}/${year}`;
      }
      if (month <= 9) {
        return `0${day}/0${month}/${year}`;
      } else {
        return `${day}/${month}/${year}`;
      }
    };

    return {
      format,
    };
  },
  data() {
    return {
      status: [
        {
          id: 1,
          value: "registred",
          name: "Enregistré",
        },
        {
          id: 2,
          value: "not_registred",
          name: "Non enregistré",
        },
      ],
      loading: false,
      pagination: {},
      total: 0,
      last_page: null,
      classes: [],
      courses: [],
      levels: [],
      datea: null,
      readInput: true,
      showFil: false,
      params: {
        q: "",
        limit: 7,
        page: 1,
        sort: "",
        order: false,
        class_id: [],
        course_id: [],
        selected_status: null,
        birthday: null,
        datede: null,
        hasfilter: false,
      },
      selectedLevel: null,
      selectedClass: [],
      selectedCourse: [],
      selectedStatus: null,
      teachers: [],
      selected: [],
      moment: null,
      pageDetail: null,
      passageYears: null,
    };
  },
  watch: {
    getPassageYears(val) {
      if (val.id) {
        this.selectedStatus = null;
        this.params.q = "";
        this.params.class_id = null;
        this.params.course_id = null;
        this.params.selected_status = null;
        this.passageYears = val.id;
        this.selectedClass = [];
        this.selectedCourse = [];
        this.ListTeachers();
        this.getFiltre();
      }
    },
  },
  created() {
    this.moment = moment;
    this.pageDetail = localStorage.getItem("detail");

    if (this.getPassageYears.id) {
      this.passageYears = this.getPassageYears.id;
      this.ListTeachers();
      this.getFiltre();
    }
  },
  computed: {
    ...mapGetters(["getPassageYears"]),
    statusClass() {
      return (teacher) => {
        if (teacher.teacher_account_status == 1) {
          return "blocked_status";
        }
        return teacher.status === 1 ? "active_status" : "noActive_status";
      };
    },
    statusText() {
      return (teacher) => {
        return teacher.status === 1 ? this.$t("common.save") : this.$t("common.noSave");
      };
    },
    statusSchoolYear() {
      return this.getPassageYears.status;
    },
    selectAll: {
      get: function () {
        return this.teachers ? this.selected.length == this.teachers.length : false;
      },
      set: function (value) {
        let selected = [];

        if (value) {
          this.teachers.forEach(function (teacher) {
            selected.push(teacher.id);
          });
        }

        this.selected = selected;
      },
    },
  },
  mounted() {},
  methods: {
    ...mapActions(["blocageTeacher"]),
    blocageTeacherFn(teacher) {
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });
      swalWithBootstrapButtons
        .fire({
          title:
            teacher.teacher_account_status == 0 || teacher.teacher_account_status == null ? this.$t("common.confirmBlockedTeacher") : this.$t("common.confirmDeblockedTeacher"),
          icon: "warning",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          this.selected = [];
          if (result.isConfirmed) {
            const params = {
              id: teacher.id,
              payload: {
                status: teacher.teacher_account_status == 0 || teacher.teacher_account_status == null ? 1 : 0,
              },
            };
            this.blocageTeacher(params).then(
              () => {
                const status = teacher.teacher_account_status == 0 || teacher.teacher_account_status == null ? 1 : 0;
                swalWithBootstrapButtons.fire(status == 0 ? this.$t("common.teacherDeblocked") : this.$t("common.teacherBlocked"), "", "success");
                this.getResults();
              },
              (error) => {
                this.loading = false;
              }
            );
          }
        });
    },
    setItem() {
      localStorage.setItem("detail", true);
    },
    clearSavedPage() {
      localStorage.removeItem("detail");
    },

    formatPhone(value) {
      const phoneNumber = parsePhoneNumberFromString(value, "TN");
      return phoneNumber ? phoneNumber.formatNational() : "";
    },
    ChangeClass(e) {
      if (e != null && e.length !== 0) {
        this.params.class_id = [];
        this.params.course_id = [];
        this.params.class_id = Object.entries(e).map(([key, value]) => value.id);
      } else {
        this.params.class_id = [];
      }
      //this.loadMatier(e);
      this.getResults();
    },
    loadMatier(classe) {
      if (classe) this.courses = _.orderBy(classe[0].courses, "name");
    },
    showFilter() {
      this.showFil = !this.showFil;
    },
    ChangeCourse(e) {
      if (e != null) {
        this.params.course_id = e;
      } else {
        this.params.course_id = [];
      }
      this.getResults();
    },

    getFiltre() {
      TeacherService.getFilterCourses({
        params: {
          class_id: this.params.class_id,
          course_id: this.params.course_id,
          sort: this.params.sort,
          order: this.params.order,
          school_year: this.passageYears,
        },
      })
        .then(
          (response) => {
            this.classes = _.orderBy(response.data.classes, "name");
            this.courses = _.orderBy(response.data.courses, "name");
          },
          (error) => {
            this.loading = false;
          }
        )
        .finally(() => {});
    },
    ChangeStatus(e) {
      this.params.selected_status = e ? e.name : null;
      this.selectedStatus = e ? e.value : null;
      this.getResults();
      this.params.hasfilter = true;
    },
    resetFilter() {
      this.selectedStatus = null;
      this.params.q = "";
      this.params.class_id = null;
      this.params.course_id = null;
      this.params.selected_status = null;
      this.passageYears = val.id;
      this.selectedClass = [];
      this.selectedCourse = [];
      this.ListTeachers();
      this.getFiltre();
    },
    deleteTeacher(id) {
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });
      const index = this.teachers.findIndex((items) => items.id === id);
      swalWithBootstrapButtons
        .fire({
          title: this.$t("common.confirmDeleteTeacher"),
          icon: "warning",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(this.$t("common.teacherDeleted"), "", "success");

            TeacherService.delete(id).then(
              () => {
                this.teachers = [];
                this.getResults();
              },
              (error) => {
                this.loading = false;
              }
            );
          }
        });
    },
    deleteSelected() {
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });
      swalWithBootstrapButtons
        .fire({
          title: this.$t("common.confirmDeleteSelectedTeacher"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(this.$t("common.teacherSelectedDeleted"), "", "success");
            TeacherService.deleteAll({
              params: {
                teachersId: this.selected,
              },
            }).then(
              () => {
                this.teachers = [];
                this.getResults();
              },
              (error) => {
                this.loading = false;
              }
            );
          }
        });
    },
    specTri(param, order) {
      if (this.params.order === null && this.params.sort === "") {
        return "";
      } else {
        if (this.params.sort === param) {
          if (this.params.order === order) {
            return "ordredA";
          } else {
            return "ordredD";
          }
        } else {
          return "";
        }
      }
    },
    sortB: _.debounce(function (param) {
      this.params.order = this.params.order === false ? true : false;
      this.params.sort = param;
      this.ListTeachers();
    }, 200),
    sort(order, sort) {
      this.params.order = order;
      this.params.sort = sort;
      this.ListTeachers();
    },
    dateTime(value) {
      return moment(value).locale("fr").format("YYYY-MM-DD");
    },
    ListTeachers() {
      this.loading = true;
      TeacherService.getAll({
        params: {
          q: this.params.q,
          limit: this.params.limit,
          sort: this.params.sort,
          order: this.params.order,
          class_id: this.params.class_id,
          course_id: this.params.course_id,
          action: this.selectedStatus,
          school_year: this.passageYears,
        },
      })
        .then(
          (response) => {
            this.teachers = response.data.data;
            const savedPage = localStorage.getItem("currentPageTeacher");
            if (savedPage && this.pageDetail) {
              this.params.page = Number(savedPage);
              this.getResults(null, this.params.page);
            }
            this.pagination = this.makePagination(response.data.meta, response.data.links);
            this.total = response.data.meta.total;
            this.last_page = response.data.meta.last_page;
            this.loading = false;
          },
          (error) => {
            this.loading = false;
          }
        )
        .finally(() => {
          this.clearSavedPage();
        });
    },
    makePagination(meta, links) {
      return {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: links.next,
        prev_page_url: links.prev,
      };
    },
    getResults(page = null, param) {
      this.selected = [];
      if (param) {
        this.params.page = param;
      } else {
        this.params.page = !page ? this.params.page : page;
      }
      localStorage.setItem("currentPageTeacher", this.params.page); // Ajout de la page courante dans le localStorage

      this.loading = true;
      this.loading = true;

      TeacherService.getAll({
        params: {
          q: this.params.q,
          limit: this.params.limit,
          page: this.params.page,
          sort: this.params.sort,
          order: this.params.order,
          class_id: this.params.class_id,
          course_id: this.params.course_id,
          action: this.selectedStatus,
          school_year: this.passageYears,
        },
      })
        .then((response) => {
          this.teachers = response.data.data;
          this.pagination = this.makePagination(response.data.meta, response.data.links);
          this.total = response.data.meta.total;
          this.loading = false;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    searshTeacher: _.debounce(function () {
      if (this.params.q.toString().length > 1 || !this.params.q.toString().length) {
        this.params.hasfilter = true;
        this.ListTeachers();
      }
    }, 200),
  },
};
</script>
